import * as angular from 'angular';

class DuplicateValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpDuplicateValidator'] = (
            modelValue: string,
            viewValue: string
        ): boolean => {
            const array: any[] = scope.$eval(attrs.pkpDuplicateValidator);

            if (array.length < 2) {
                return true;
            }

            return !array
                .filter((emailAddress) => !!emailAddress)
                .some((value, index, array) => array.indexOf(value) !== index);
        };
    };
}

DuplicateValidator.$inject = [];

angular
    .module('app')
    .directive('pkpDuplicateValidator', () => new DuplicateValidator());
